const MAX_DIAGNOSTIC_LENGTH = 100;

function getBoundedValue(value: unknown): string | undefined {
  if (typeof value !== 'string' && typeof value !== 'number' && typeof value !== 'boolean') {
    return undefined;
  }

  const stringValue = String(value);
  return stringValue.length > MAX_DIAGNOSTIC_LENGTH ? `${stringValue.slice(0, MAX_DIAGNOSTIC_LENGTH)}…` : stringValue;
}

export interface ErrorDiagnostics {
  errorType: string;
  errorName?: string;
  errorCode?: string;
  errorStatus?: string;
}

export function getErrorDiagnostics(error: unknown): ErrorDiagnostics {
  const diagnostics: ErrorDiagnostics = {
    errorType: error instanceof Error ? 'Error' : Array.isArray(error) ? 'array' : typeof error
  };

  if (!error || typeof error !== 'object') {
    return diagnostics;
  }

  try {
    const errorRecord = error as Record<string, unknown>;
    const errorName = getBoundedValue(errorRecord.name);
    const errorCode = getBoundedValue(errorRecord.code);
    const errorStatus = getBoundedValue(errorRecord.statusCode ?? errorRecord.status);

    if (errorName) {
      diagnostics.errorName = errorName;
    }
    if (errorCode) {
      diagnostics.errorCode = errorCode;
    }
    if (errorStatus) {
      diagnostics.errorStatus = errorStatus;
    }
  } catch {
    return { errorType: diagnostics.errorType };
  }

  return diagnostics;
}
